import { decode } from './base64url'

function getScoreIdDecoded(encodedScoreId: string) {
    if (encodedScoreId == null) {
        return null
    }

    try {
        return decode(encodedScoreId, 'utf8')
    } catch (err) {
        return encodedScoreId
    }
}

export default getScoreIdDecoded
